<div class="bo-toast__layout">
  <span class="bo-feedback__icon" aria-hidden="true"><i class="bi" [ngClass]="icon"></i></span>
  <div class="bo-toast__copy" [attr.role]="tone === 'error' ? 'alert' : 'status'" aria-atomic="true">
    <div class="bo-toast__title">
      {{ title || (titleKey | translate) }}
      <span *ngIf="duplicatesCount"> ({{ duplicatesCount + 1 }})</span>
    </div>
    <div *ngIf="message && !options.enableHtml" class="bo-toast__message">{{ message }}</div>
    <div *ngIf="message && options.enableHtml" class="bo-toast__message" [innerHTML]="message"></div>
  </div>
  <button *ngIf="options.closeButton" class="bo-feedback__close" type="button" (click)="dismiss($event)" [attr.aria-label]="'ac_close' | translate">
    <i class="bi bi-x" aria-hidden="true"></i>
  </button>
</div>
<div *ngIf="options.progressBar && width >= 0 && options.timeOut" class="bo-toast__progress" [style.width.%]="width" aria-hidden="true"></div>
